import { useDispatch, useSelector } from 'react-redux';
import { selectIssueDesc, selectShowInvalids } from '@store/order/selectors';
import { setIssueDesc } from '@store/order/slice';
import TextArea from '@components/text-field/TextArea';
import SurgeryDate from '@pages/order/surgery-info/SurgeryDate';
import { invalidFormValue } from '@components/utils';



const SurgeryInfo = (): JSX.Element => {

	const issueDesc = useSelector(selectIssueDesc);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateIssueDesc = (value: string | null) => dispatch(setIssueDesc(value));

	return (
		<div className='surgery-info-section'>

			<TextArea
				label='Potíže/Plánovaný zákrok'
				required={true}
				rounded={true}
				maxLength={250}
				description='(uveďte co nejkonkrétněji místo zranění)'
				value={issueDesc ? issueDesc : undefined}
				onChange={(value: string) => !value && value.length === 0 ? updateIssueDesc(null) : updateIssueDesc(value)}
				errorMessage={showInvalids && invalidFormValue(issueDesc) ? 'Povinné pole' : undefined} />

			<SurgeryDate />

		</div>
	);
};

export default SurgeryInfo;